import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Route as RootRoute } from './__root';

// /admin/*: admin-only console with its own layout and guard (see AdminLayout).
export const AdminRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/admin',
  component: lazyRouteComponent(() => import('../components/admin/shell'), 'AdminLayout'),
});

export const AdminIndexRoute = createRoute({
  getParentRoute: () => AdminRoute,
  path: '/',
  component: lazyRouteComponent(() => import('../pages/admin/overview'), 'AdminOverviewPage'),
});

export const AdminLeadsRoute = createRoute({
  getParentRoute: () => AdminRoute,
  path: '/leads',
  component: lazyRouteComponent(() => import('../pages/admin/leads'), 'AdminLeadsPage'),
});

export const AdminLeadDetailRoute = createRoute({
  getParentRoute: () => AdminRoute,
  path: '/leads/$leadId',
  component: lazyRouteComponent(() => import('../pages/admin/leads'), 'AdminLeadDetailPage'),
});

export const AdminOrgsRoute = createRoute({
  getParentRoute: () => AdminRoute,
  path: '/orgs',
  component: lazyRouteComponent(() => import('../pages/admin/orgs'), 'AdminOrgsPage'),
});

export const AdminOrgDetailRoute = createRoute({
  getParentRoute: () => AdminRoute,
  path: '/orgs/$orgId',
  component: lazyRouteComponent(() => import('../pages/admin/orgs'), 'AdminOrgDetailPage'),
});

export const AdminActivityRoute = createRoute({
  getParentRoute: () => AdminRoute,
  path: '/activity',
  component: lazyRouteComponent(() => import('../pages/admin/activity'), 'AdminActivityPage'),
});

export const AdminSystemRoute = createRoute({
  getParentRoute: () => AdminRoute,
  path: '/system',
  component: lazyRouteComponent(() => import('../pages/admin/system'), 'AdminSystemPage'),
});
